var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2084_148973)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58173 12.4183 0 8 0C3.58173 0 0 3.58173 0 8C0 12.4183 3.58173 16 8 16ZM8 4.71429C7.36882 4.71429 6.85714 5.22597 6.85714 5.85714C6.85714 6.33053 6.47338 6.71429 6 6.71429C5.52662 6.71429 5.14286 6.33053 5.14286 5.85714C5.14286 4.27919 6.42205 3 8 3C9.57795 3 10.8571 4.27919 10.8571 5.85714C10.8571 7.13647 10.0163 8.21941 8.85714 8.58349V8.71429C8.85714 9.18767 8.47338 9.57143 8 9.57143C7.52662 9.57143 7.14286 9.18767 7.14286 8.71429V7.85714C7.14286 7.38376 7.52662 7 8 7C8.63118 7 9.14286 6.48832 9.14286 5.85714C9.14286 5.22597 8.63118 4.71429 8 4.71429ZM8 10.7143C8.63118 10.7143 9.14286 11.226 9.14286 11.8571C9.14286 12.4883 8.63118 13 8 13C7.36882 13 6.85714 12.4883 6.85714 11.8571C6.85714 11.226 7.36882 10.7143 8 10.7143Z",
    fill: "#EB3366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2084_148973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/infoOutline.b4d2a75604d14f42ba543a05861b20e9.svg";
export { ForwardRef as ReactComponent };